export function getTreeItem(tree, itemIndex) {
    let item = { children: tree };
    const indexes = itemIndex.split('_');
    indexes.forEach(index => {
        item = item.children[index];
    });
    return item;
}

export function removeTreeViewItem(tree, itemIndex) {
    const indexes = itemIndex.split('_');
    let item = { children: tree };
    let parent = null;
    indexes.forEach((index, i) => {
        if (i === indexes.length - 1) {
            parent = item;
        }
        item = item.children[index];
    });
    const index = indexes[indexes.length - 1];
    parent.children.splice(index, 1);
    return tree;
}